// 全站文案，按命名空间组织：common（通用 UI）+ 各页面 + arch（平台架构组件）。
// 定位：能源系统的数字化与智能化赋能者，让能源资产更具价值。
export const zh = {
  common: {
    nav: { home: "首页", products: "产品", about: "公司", contact: "联系我们" },
    actions: {
      cooperate: "开启合作",
      viewAllProjects: "查看全部项目",
      learnTeam: "了解团队",
      viewProducts: "查看产品",
    },
    cta: {
      default: {
        title: "让我们一起提升能源资产价值",
        description:
          "以软硬件一体解决方案与算法资源库，承接节能业务与智能化运维改造 —— 欢迎与我们探讨您的能源数字化需求。",
      },
      products: {
        title: "探讨您的项目需求",
        description:
          "从能源平台、智能硬件到算法与运维改造，我们提供从方案设计、落地交付到持续运维的一体化服务。",
      },
      about: {
        title: "进一步了解赋维世",
        description: "在技术合作、联合开发与学术交流等方面，欢迎与赋维世团队联系。",
      },
    },
    theme: { toggle: "切换主题", toLight: "切换到浅色", toDark: "切换到深色" },
    language: { switch: "切换语言" },
    footer: {
      tagline: "能源系统的数字化与智能化赋能者，提供软硬件一体的解决方案与算法资源。",
      nav: "导航",
      contact: "联系我们",
    },
    lightbox: { zoom: "查看 {{name}} 大图", close: "关闭" },
  },

  home: {
    hero: {
      slides: [
        {
          title: ["解构复杂网络", "唤醒原生智能"],
          subtitle: "将孤立的能源节点，重塑为具备感知与决策能力的自演进网络。",
        },
        {
          title: ["穿透软硬壁垒", "淬炼一体心智"],
          subtitle: "从边缘传感、核心算法到全局统御，坚持全链路自主研发，构筑不可逾越的技术护城河。",
        },
        {
          title: ["突破效能极限", "升维资产价值"],
          subtitle: "在电力、配电、暖通与储能场景中，以精准的算法寻优实现可靠运行与商业回报的跨越。",
        },
      ],
      primaryCta: "了解解决方案",
      secondaryCta: "联系合作",
      badge: "能源系统的数字化与智能化赋能者",
      proof: [
        { value: "软硬件一体", label: "全链路自主研发" },
        { value: "15+", label: "能效与调度算法" },
        { value: "全场景", label: "电力 · 配电 · 暖通 · 储能" },
      ],
    },
    capabilities: {
      eyebrow: "软硬件一体 · 算法驱动",
      heading: "以软硬件一体与算法资源，赋能能源系统",
      intro:
        "围绕能源资产的全生命周期，提供从智能硬件、能源平台到算法与运维的一体化能力，持续提升能效与资产价值。",
      items: [
        { title: "软硬件一体解决方案", desc: "高效集成感知硬件、边缘计算与能源平台，方案快速落地、稳定可靠。" },
        { title: "丰富的算法资源库", desc: "能效测评、预测、优化调度与运行控制等算法沉淀，可直接复用。" },
        { title: "节能业务", desc: "承接能效诊断与节能改造，以数据驱动持续降低能耗与成本。" },
        { title: "智能化运维改造", desc: "让既有能源资产实现远程监控、智能诊断与自动调度。" },
      ],
    },
    arch: {
      titleBefore: "构筑",
      titleHighlight: "自演进",
      titleAfter: "的能源智能体",
      subtitle:
        "打破系统孤岛，让数据、算法与硬件在统一的架构中同频共振，锁定最优能效路径。",
    },
    focus: {
      eyebrow: "我们创造的价值",
      heading: "用数据与算法，让能源更高效",
      intro:
        "面向电力、配电、暖通、储能等能源场景，以软硬件一体方案与算法资源库，围绕能效提升、智能运维与节能改造，让能源资产持续增值。",
      points: ["能效监测与诊断", "智能调度与控制", "节能改造", "智能化运维"],
      note: "无论何种能源场景，我们都能以数据创造价值。",
      imageAlt: "能源数据大屏",
      badge: { value: "实时", label: "能效监测与告警" },
    },
    stats: {
      products: "自研产品与平台",
      algorithms: "能效与调度算法",
      partners: "合作伙伴与机构",
      directions: "核心业务方向",
    },
    featured: { eyebrow: "代表案例", heading: "已落地的能源数字化方案" },
  },

  arch: {
    layers: { llm: "大模型", app: "应用层", algo: "算法资源库", edge: "边缘与硬件" },
    cta: "查看完整平台架构",
    concept: { llm: "全局统御", app: "协同中枢", algo: "机理认知", edge: "微观感知" },
    desc: {
      llm: "驱动复杂场景的行业大模型，在海量多维变量中持续推演并锁定全局最优决策。",
      app: "承载核心业务逻辑的软硬一体平台，将智能指令转化为切实的能效提升与可靠运维。",
      algo: "沉淀深厚行业经验的专有算法库，精准解码电力与暖通流转的内在物理规律。",
      edge: "边缘硬件与传感器网络深入物理肌理，精准映射能源资产的实时运行状态。",
    },
    llmModules: ["智能问答", "归因诊断", "决策调度", "报告生成"],
    appModules: ["监控中心", "能效分析", "智能运维", "虚拟电厂"],
    algoModules: ["能效测评", "负荷预测", "优化调度", "运行控制"],
    edgeModules: ["智能控制器", "智能配电柜", "能源网关", "多协议接入"],
  },

  products: {
    banner: {
      title: "产品与解决方案",
      eyebrow: "软硬一体 · 算法驱动",
      subtitle:
        "面向能源系统的数字化与智能化 —— 以软硬件一体方案与算法资源库，覆盖能效提升、节能改造与智能运维。",
    },
    archSection: {
      eyebrow: "平台架构",
      title: "纯粹的底层重构，而非系统拼图",
      subtitle:
        "真正的智能无法通过多方妥协与堆砌实现，我们以纯粹的自研体系，确保从感知到决策的绝对咬合。",
    },
    catSection: { eyebrow: "产品 / 案例", title: "解决方案分类" },
    categoryLabels: {
      all: "全部",
      smartEnergy: "智慧能源",
      productRnD: "产品研发",
      aiService: "AI服务",
    },
    categoryIntro: {
      smartEnergy:
        "能源管理后台、能源数据大屏与智能控制器、配电柜等软硬件，覆盖监测、分析、告警与节能优化。",
      productRnD:
        "软件 / 嵌入式 / 硬件的定制承接与联合开发，代表交付如边缘工控机 / 能源网关，亦承接跨行业项目。",
      aiService: "大模型接入与应用落地服务，帮助企业快速集成 AI 能力到业务系统。",
    },
    items: {
      pvPlatform: {
        name: "能源管理平台（数据大屏）",
        desc: "面向电站与园区的综合能效大屏，实时呈现发电与用电功率、设备效率、储能与电网状态及能耗分析，让运营状态与节能成效一目了然。",
        tags: ["软件平台", "数据可视化", "能源"],
      },
      energyBackend: {
        name: "能源管理后台系统",
        desc: "Web 端能源管理系统，覆盖实时监控、设备管理、能耗分析、告警中心与报表中心，支持分部门/分项能耗对比与峰谷电价策略。",
        tags: ["软件平台", "物联管理", "能耗分析"],
      },
      chillerDashboard: {
        name: "冷水机组运维大屏",
        desc: "面向中央空调冷水机组的运维监控大屏，实时呈现冷水机组、冷冻/冷却水泵、冷却塔的运行状态与能耗，结合 COP 能效分析与告警，助力机房节能与智慧运维。",
        tags: ["软件平台", "数据可视化", "暖通空调"],
      },
      pvController: {
        name: "智能光伏控制器",
        desc: "户外级智能光伏控制/汇流设备，集成数据采集与通信，软硬协同上报至平台，提升发电效率与远程运维能力。",
        tags: ["智能硬件", "嵌入式", "光伏"],
      },
      switchgear: {
        name: "智能配电柜",
        desc: "集断路保护、继电控制、数据采集与远程通信于一体的智能配电柜，支持回路监测、异常告警与远程联动，让配电从被动维护走向主动智能。",
        tags: ["智能硬件", "配电", "物联"],
      },
      edgeGateway: {
        name: "边缘工控机 / 能源网关",
        desc: "面向现场的无风扇工业级边缘主机，多网口与串口（RS232/485）支持多协议设备接入与就地计算，作为现场设备与云端平台之间的数据中枢，保障弱网/离线下的稳定运行。",
        tags: ["产品研发", "边缘计算", "网关"],
      },
      llmService: {
        name: "大模型接入服务",
        desc: "提供主流大模型的接入与应用落地服务，覆盖模型选型、私有化部署、知识库与智能问答、Agent 工作流等，帮助企业快速将 AI 能力集成到业务系统中。",
        tags: ["AI服务", "大模型", "应用集成"],
      },
    },
    process: {
      eyebrow: "合作流程",
      title: "从需求到落地的五步",
      steps: [
        { title: "需求沟通", desc: "理解场景与目标，明确边界。" },
        { title: "方案设计", desc: "软硬件选型与架构设计。" },
        { title: "软硬件开发", desc: "嵌入式、平台与算法并行。" },
        { title: "测试交付", desc: "现场联调与稳定性验证。" },
        { title: "运维迭代", desc: "持续优化与功能演进。" },
      ],
    },
  },

  about: {
    banner: {
      title: "关于赋维世",
      eyebrow: "上海赋维世科技",
      subtitle: "能源系统的数字化与智能化赋能者，以软硬件一体方案与算法资源，让能源资产更具价值。",
    },
    intro: {
      eyebrow: "我们是谁",
      heading: "能源系统的数字化与智能化赋能者",
      p1: "赋维世（Furtherverse）专注于能源系统的数字化与智能化，以软硬件一体的解决方案与丰富的算法资源，帮助客户提升能效、优化运维，让能源资产更具价值。",
      p2: "我们承接各类节能业务与智能化运维改造，覆盖电力、配电、暖通、储能等能源场景，以数据与算法驱动持续优化。",
      imageAlt: "赋维世技术能力",
    },
    advantagesSection: { eyebrow: "核心优势", heading: "为什么选择我们" },
    advantages: [
      { title: "软硬件一体解决方案", desc: "感知硬件、边缘与平台高效集成，方案快速落地、稳定可靠。" },
      { title: "丰富的算法资源库", desc: "能效、预测、优化调度与运行控制等算法沉淀，缩短交付周期。" },
      { title: "节能与运维改造", desc: "承接能效诊断、节能改造与智能化运维，以数据驱动降耗。" },
      { title: "院校与机构合作", desc: "与华东师范大学等院校及研究机构保持合作。" },
    ],
    partnersSection: { eyebrow: "合作伙伴 / 学术资源", heading: "长期合作的伙伴与机构" },
    partners: {
      zxx: "智信鑫",
      runda: "润达光伏",
      enxi: "恩喜村",
      mps: "公安部第三研究所",
      ecnu: "华东师范大学",
    },
  },

  contact: {
    banner: {
      title: "联系我们",
      eyebrow: "商务合作 · 技术交流",
      subtitle: "无论项目开发或技术合作，欢迎通过以下方式与我们联系。",
    },
    email: { label: "邮箱" },
    phone: { label: "电话", role: "商务主管 · 王晨曦" },
    wechat: { label: "微信", hint: "点击放大 · 扫码添加", modalHint: "扫码添加微信" },
  },
};

export type Resources = typeof zh;
